import { useState, useEffect } from "react";
import styles from "./MobileHeader.module.scss";
import Link from "../Link";
import { useRouter } from "next/router";
import utils from "../../../utils";
import store from "../../../redux/Store";
import { Modal } from "antd";
const buyLinkName = "Add Credits";

const MobileHeader = () => {
  const router = useRouter();
  const [show, setShow] = useState(false);
  const routerName = router.pathname;
  const [login, setLogin] = useState(false);
  let isAppleDevice = false
  if (typeof window !== 'undefined') {
    isAppleDevice = !!(window.navigator.userAgent.toLocaleLowerCase().match(/ios|ipad|iphone|mac/));
  }

  useEffect(() => {
    if (utils.isLogin() === 1) {
      setLogin(true);
    }

    store.subscribe(() => {
      let { isLogin } = store.getState();
      console.log("Subscribe:", isLogin);
      if (isLogin) {
        setLogin(true);
      }
    });
  }, []);

  return (
    <header className={styles.header + " " + "row1 jb ac"}>
      <div>
        <Link href="/">
          <a>
            <img
              className={styles.fl}
              src={"/images/header/nav_logo.png"}
              alt=""
            ></img>
          </a>
        </Link>
        {(routerName === "/index1" || routerName === "/download1") && (
          <p className={styles.fl__desc}>Pick your 2nd phone number</p>
        )}
      </div>
      <img
        className={styles.fr}
        onClick={() => {
          setShow(true);
        }}
        src={"/images/header/nav.png"}
        alt=""
      ></img>
      {show && (
        <div
          className={
            styles.menuBar + " " + (show ? styles.fadeIn : styles.fadeOut)
          }
        >
          <div className={styles.menuBar__f1 + " " + "row1 jb ac"}>
            <Link href="/">
              <a>
                <img
                  className={styles.logo}
                  src={"/images/header/nav_logo.png"}
                  alt=""
                ></img>
              </a>
            </Link>
            <img
              className={styles.close}
              onClick={() => {
                setShow(false);
              }}
              src={"/images/header/close.png"}
              alt=""
            ></img>
          </div>
          <div className={styles.menuBar__f2}>
            <Link href="/phone-number">
              <a>
                <div className={styles.menu__item}>
                  <span>Phone Number</span>
                </div>
              </a>
            </Link>
            <Link href="/free-calls-and-free-texts">
              <a>
                <div className={styles.menu__item}>
                  <span>Free Calls & Texts</span>
                </div>
              </a>
            </Link>
            <a href="http://blog.dingtone.me/en/">
              <div className={styles.menu__item}>
                <span>Blog</span>
              </div>
            </a>
            <Link href="/support">
              <a>
                <div className={styles.menu__item}>
                  <span>Support</span>
                </div>
              </a>
            </Link>
            <Link href="/dingtone-free-download">
              <a>
                <div className={styles.menu__item}>
                  <span>Download</span>
                </div>
              </a>
            </Link>
            {
              isAppleDevice ?
              ''
              :
              <Link href="https://og.dingtone.me/en/buy/">
                <a>
                  <div className={styles.menu__item}>
                    <span>{buyLinkName}</span>
                  </div>
                </a>
              </Link>
            }

            {/* todo */}
            {login ? (
              <Link href="/my/home">
                <a>
                  <div className={styles.menu__item}>
                    <span>Account</span>
                  </div>
                </a>
              </Link>
            ) : (
              <Link href="/account/login_email">
                <a>
                  <div className={styles.menu__item}>
                    <span>Log In</span>
                  </div>
                </a>
              </Link>
            )}
          </div>
          <div className={styles.menuBar__f3}>
            <div className={styles.line}></div>
            <div className={styles.media_box + " " + "row1 jb ac"}>
              <span>Copyright © 2021 Dingtone</span>
              <div>
                <a href="http://www.twitter.com/Dingtone" target="_blank">
                  <img
                    className={styles.media}
                    src={"/images/footer/icon_twitter@2x.png"}
                    alt=""
                  />
                </a>
                <a href="http://www.facebook.com/Dingtone" target="_blank">
                  <img
                    className={styles.media}
                    src={"/images/footer/icon_fb@2x.png"}
                    alt=""
                  />
                </a>
                <a href="" target="_blank">
                  <img
                    className={styles.media}
                    src={"/images/footer/icon_in@2x.png"}
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
